import { useState, useEffect } from "react"
import styles from "./hero.module.css"

export default function Hero() {
  const [glitchActive, setGlitchActive] = useState(false)

  useEffect(() => {
    const interval = setInterval(() => {
      setGlitchActive(true)
      setTimeout(() => setGlitchActive(false), 200)
    }, 4000)
    return () => clearInterval(interval)
  }, [])

  return (
    <section className={styles.hero}>
      <div className={styles.heroContent}>
        <div className={`${styles.title} ${glitchActive ? styles.glitch : ""}`}>
          <h1>PIXEL MOON</h1>
          <span className={styles.subtitle}>A Revolution for Gamers</span>
        </div>

        <p className={styles.tagline}>Born from the grind. Built for the players. Powered by fairness.</p>

        <div className={styles.badges}>
          <span className={styles.badge}>⚡ Fair Pricing</span>
          <span className={styles.badge}>🛡️ Secure</span>
          <span className={styles.badge}>🚀 Fast</span>
        </div>
      </div>

      <div className={styles.heroVisual}>
        <div className={styles.moonOrb} />
        <div className={styles.particles}>
          {[...Array(18)].map((_, i) => (
            <div key={i} className={styles.particle} style={{ "--delay": `${i * 0.1}s` }} />
          ))}
        </div>
      </div>
    </section>
  )
}
